// 判断浏览器版本
function IEVersion() {
    var userAgent = navigator.userAgent
    var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
    var isEdge = userAgent.indexOf('Edge') > -1 && !isIE
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    if (isIE) {
        var reIE = new RegExp('MSIE (\\d+\\.\\d+)')
        reIE.test(userAgent)
        var fIEVersion = parseFloat(RegExp['$1'])
        if (fIEVersion === 7) {
            return 7
        } else if (fIEVersion === 8) {
            return 8
        } else if (fIEVersion === 9) {
            return 9
        } else if (fIEVersion === 10) {
            return 10
        } else {
            return 6
        }
    } else if (isEdge) {
        return 'edge'
    } else if (isIE11) {
        return 11
    } else {
        return -1
    }
}
// IE11及一下 添加数组find方法
function arrayFind() {
    let version = IEVersion()
    if (typeof version === 'number' && version !== -1 && version <= 11) {
        window.Array.prototype.find = function(callback) {
            for (var i = 0; i < this.length; i++) {
                var res = callback(this[i])
                if (res) {
                    return res
                }
            }
        }
    }
}

arrayFind()

// IE11及一下 添加数组和字符串的includes方法
function arrayIncludes() {
    let version = IEVersion()
    if (typeof version === 'number' && version !== -1 && version <= 11) {
        window.Array.prototype.includes = function(item) {
            for (var i = 0; i < this.length; i++) {
                if (this[i] === item) { return true }
            }
            return false
        }
        window.String.prototype.includes = function(str) {
            if (this.indexOf(str) === -1) {
                return false
            } else {
                return true
            }
        }
    }
}

arrayIncludes()

// IE11及一下 添加数组FindIndex方法
function arrayFindIndex() {
    let version = IEVersion()
    if (typeof version === 'number' && version !== -1 && version <= 11) {
        window.Array.prototype.findIndex = function(callback) {
            let length = this.length;
            for (let i = 0; i < length; i++) {
                if (callback(this[i])) {
                    return i
                }
            }
        }
    }
}

arrayFindIndex()


// WEBPACK FOOTER //
// ./src/IE.js